module.exports = __webpack_public_path__ + "static/media/chair.396b7f1c.png";